import React from "react";

import styles from "./folder-add-button.module.scss";
import { FolderAddButtonDispatchProps } from "./folder-add-button.types";

const FolderAddButton: React.FC<FolderAddButtonDispatchProps> = (props: FolderAddButtonDispatchProps) => {
  return (
    <div onClick={(): void => props.chatFolderModalIsOpen(true)} className={styles.FolderAddButtonWrapper}>
      +
    </div>
  );
};

export default FolderAddButton;
